export default __webpack_public_path__ + "static/media/logo_branca.6d063f1a.png";